import api from '@anm/api';
import { JobIdFromSourceParams, JobIdFromTextParams } from '@anm/api/modules/storyboard';
import asyncEntity from '@anm/helpers/redux/asyncEntity';
import { call, fork, take } from '@anm/helpers/saga/effects';
import { takeType } from '@anm/helpers/saga/typesafe-actions';

import { storyboardActions } from '.';

const fetchJobIdFromUrlAsync = asyncEntity(storyboardActions.fetchUrlJobIdAsync, (props: JobIdFromSourceParams) =>
  api().storyboard.getJobIdFromUrl(props)
);

const fetchJobIdFromTextAsync = asyncEntity(storyboardActions.fetchTextJobIdAsync, (props: JobIdFromTextParams) =>
  api().storyboard.getJobIdFromText(props)
);

function* watchFetchJobIdFromSourceAsync() {
  while (true) {
    const { payload } = yield* take(takeType(storyboardActions.fetchUrlJobId));
    yield fork(fetchJobIdFromUrlAsync, payload, payload);
  }
}

function* watchFetchJobIdFromTextAsync() {
  while (true) {
    const { payload } = yield* take(takeType(storyboardActions.fetchTextJobId));
    yield fork(fetchJobIdFromTextAsync, payload);
  }
}

const storyboardSagaWatchers = () => [call(watchFetchJobIdFromSourceAsync), call(watchFetchJobIdFromTextAsync)];

export default storyboardSagaWatchers;
